//AddTask form label 

export const taskLabels = {
  company: "Company Name",
  companyBranch: "Company Branch",
  taskLabels: "Task Title",
  taskDescription: "Task Description",
  assignedTo: "Assigned To",
  contactTo: "Contact To",
  taskStartDateTime: "Start Date/Time",
  taskEndDateTime: "End Date/Time",
  taskStatus: "Task Status",
};

//AddLead form label 

export const leadLabels = {
  company: "Company Name",
  companyBranch: "Company Branch",
};

//AddContact form label 

export const contactLabels = {
  firstName: "First Name",
  lastName: "Last Name",
  contactLabels: "Contact Name",
  contactDesignation: "Designation",
  contactNumber: "Contact Number",
  contactEmail: "Contact Email",
  decision: "Decision Maker",
};
